import React from "react";

export default function MessageInfoModal({ message, conversation, onClose }) {
  const formatTime = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const time = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
    const day = d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    return `${day} · ${time.replace(' AM','am').replace(' PM','pm')}`;
  };

  const seenTimes = (message?.read || [])
    .map((e) => e?.readAt)
    .filter(Boolean);
  const latestSeenTime = seenTimes.length
    ? new Date(Math.max(...seenTimes.map((t) => new Date(t).getTime())))
    : null;

  // For private chats, recipient is the other user
  // const otherParticipants = (conversation?.participants || []).filter(p => p._id !== message?.sender?._id);

  return (
    <div className="message_info_modal_overlay" onClick={onClose}>
      <div className="message_info_modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal_header">
          <h3 className="modal_title">Message info</h3>
          <button className="modal_close_btn" onClick={onClose} title="Close">×</button>
        </div>
        <div className="modal_body">
          <div className="message_info_section">
            <div className="message_info_row">
              <span className="message_info_label">Sent</span>
              <span className="message_info_value">{formatTime(message?.createdAt)}</span>
            </div>
          </div>

          <div className="menu_divider" style={{ margin: '8px 0' }}></div>

          <div className="message_info_section">
            <div className="message_info_row">
              <span className="message_info_label">Seen</span>
              <span className="message_info_value">
                {latestSeenTime ? formatTime(latestSeenTime) : 'Not seen yet'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
